module.exports = __webpack_public_path__ + "static/img/corss_2.a3830a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/corss_2.png
// module id = h98+
// module chunks = 1